export default __webpack_public_path__ + "static/media/orquidees.f35c7e7a.jpg";